import { render, staticRenderFns } from "./DesignFoundationsColor.vue?vue&type=template&id=79d9618a"
import script from "./DesignFoundationsColor.vue?vue&type=script&lang=js"
export * from "./DesignFoundationsColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DesignFoundationsColor.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports